import React from 'react'
import { Link } from 'react-router-dom'
import { cn } from '../../lib/utils'

export default function AuthLayout({ children, className }) {
    return (
        <div className='bg-[#F0F2F5] h-full flex items-center'>
            <div className="max-w-md mx-auto bg-white p-10 w-full min-h-[600px] flex flex-col py-20">
                <Link to="/" className="no-underline">
                    <h1 className='text-[#F78D30] font-poppins tracking-tight font-bold text-3xl md:text-5xl text-center'>
                        TRAKHIRE
                    </h1>
                </Link>

                <div className={cn('flex-grow', className)}>
                    {children}
                </div>
            </div>
        </div>
    )
}
